import { render, staticRenderFns } from "./team.vue?vue&type=template&id=4dee2c26&scoped=true"
import script from "./team.vue?vue&type=script&lang=js"
export * from "./team.vue?vue&type=script&lang=js"
import style0 from "./team.vue?vue&type=style&index=0&id=4dee2c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dee2c26",
  null
  
)

export default component.exports